import { gql } from "@apollo/client";

export const GET_RESULTS = gql`
  query Query($resultsAnswers: String) {
    results(answers: $resultsAnswers) {
      answers
      start
      end
      total
      result {
        area
        score
        description
      }
    }
  }
`;

export const GET_MATCHING_CAREERS = gql`
  query Query($matchingCareersAnswers: String) {
    matchingCareers(answers: $matchingCareersAnswers) {
      answers
      start
      end
      total
      career {
        code
        title
      }
    }
  }
`;

export const GET_OCCUPATIONS = gql`
  query Query($getOccupationsOccupationIds: [String]) {
    getOccupations(occupationIds: $getOccupationsOccupationIds) {
      occupations {
        occupationId
        title
        jobZoneId
        blsOccupationId
      }
      occupationAnnualWageMap {
        seriesId
        value
        blsIndustryId
        blsOccupationId
      }
      industryList {
        blsIndustryId
        title
      }
    }
  }
`;

export const SET_QUIZ_PROGRESS = gql`
  mutation Mutation($setQuizProgressAnswers: String) {
    setQuizProgress(answers: $setQuizProgressAnswers) {
      success
      message
      code
    }
  }
`;

export const RESET_QUIZ_PROGRESS = gql`
  mutation Mutation {
    resetQuizProgress {
      success
      message
      code
    }
  }
`;
